window.tabs = window.tabs || {};
window.tabs.bindTabEvents = (oTab) => bindTabEvents(oTab);

document.addEventListener('DOMContentLoaded', () => {
    const oTabWrappers = document.querySelectorAll('[data-has-tab]');

    oTabWrappers.forEach(oWrapper => {
        bindTabEvents(oWrapper);
    });
});

function bindTabEvents(oNode) {
    const oTabHeaders = oNode.querySelectorAll('[data-tab-header]');
    const oTabContents = oNode.querySelectorAll('[data-tab-content]');

    oTabHeaders.forEach(oHeader => {
        oHeader.addEventListener('click', function () {
            const sTabId = this.getAttribute('data-tab');

            oTabHeaders.forEach(h => h.classList.remove('active'));
            this.classList.add('active');

            oTabContents.forEach(oContent => {
                oContent.style.display = 'none';
            });

            document.getElementById(sTabId + '-tab').style.display = '';
        });
    });
}
